import {Material} from '@domain/materials'
import {TableCell, Typography} from '@mui/material'

export const EnhancersForCementClassificationRow = ({material}: {material: Material}) => (
  <>
    <TableCell>
      <Typography variant="caption">{material.classification?.category}</Typography>
    </TableCell>
    <TableCell>
      <Typography variant="caption">{material.classification?.subCategory}</Typography>
    </TableCell>
    <TableCell>
      <Typography variant="caption">{material.classification?.brand}</Typography>
    </TableCell>
    <TableCell>
      <Typography variant="caption">{material.classification?.otherBrand}</Typography>
    </TableCell>
  </>
)
